"use strict";

exports.__esModule = true;
exports.DeviceColorBox = DeviceColorBox;
var _react = _interopRequireDefault(require("react"));
var _DeviceContext = require("../DeviceContext");
var _DeviceColorController = require("./DeviceColorController");
var _excluded = ["x", "y", "width", "height", "backgroundColor", "backgroundColorSource"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Shows a solid color based on a specified background color or background color source.
 */
function DeviceColorBox(_ref) {
  var _ref$x = _ref.x,
    x = _ref$x === void 0 ? 0 : _ref$x,
    _ref$y = _ref.y,
    y = _ref$y === void 0 ? 0 : _ref$y,
    width = _ref.width,
    height = _ref.height,
    backgroundColor = _ref.backgroundColor,
    backgroundColorSource = _ref.backgroundColorSource,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (backgroundColorSource) {
    return /*#__PURE__*/_react["default"].createElement(_DeviceContext.DeviceContext.Consumer, null, function (device) {
      if (!device) {
        if (backgroundColor) {
          return /*#__PURE__*/_react["default"].createElement("svg", _extends({
            x: x,
            y: y,
            width: width,
            height: height
          }, extra), /*#__PURE__*/_react["default"].createElement("rect", {
            width: width,
            height: height,
            fill: backgroundColor
          }));
        }
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_DeviceColorController.DeviceColorController, {
        deviceUuid: device.uuid,
        backgroundColor: backgroundColor,
        backgroundColorSource: backgroundColorSource
      }, function (_ref2) {
        var backgroundColor = _ref2.backgroundColor;
        return backgroundColor == null ? null : /*#__PURE__*/_react["default"].createElement("svg", _extends({
          x: x,
          y: y,
          width: width,
          height: height
        }, extra), /*#__PURE__*/_react["default"].createElement("rect", {
          width: width,
          height: height,
          fill: backgroundColor
        }));
      });
    });
  }
  if (!backgroundColor || backgroundColor === "transparent") {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    x: x,
    y: y,
    width: width,
    height: height
  }, extra), /*#__PURE__*/_react["default"].createElement("rect", {
    width: width,
    height: height,
    fill: backgroundColor
  }));
}